import { useStore } from '../store';

export const memoryTypes = [
  {
    value: 'about-me',
    label: 'About Me',
    description: `A moment from your own life that you want to pass down.`,
    icon: 'user',
  },
  {
    value: 'family',
    label: 'Family and Friends',
    description: `A memory centered on someone special, a family, or friends that is worth preserving.`,
    icon: 'users',
  },
  {
    value: 'service',
    label: 'Service',
    description: `Military, first response, healthcare, or another way of serving others you want to highlight.`,
    icon: 'medal',
  },
  {
    value: 'pets',
    label: 'Pets',
    description: `A beloved companion and the moments you shared.`,
    icon: 'paw',
  },
  {
    value: 'event',
    label: 'Event',
    description: `A wedding, celebration, milestone, or meaningful gathering.`,
    icon: 'calendar',
  },
  {
    value: 'other',
    label: 'Other',
    description: `A place, tradition, object, or experience worth remembering.`,
    icon: 'circle-question',
  },
];

export const getMemoryType = (type: string) => {
  return memoryTypes.find((memoryType) => memoryType.value === type);
};

export const memoryPlaceholders = {
  name: 'Your name',
  dedicated_to: 'Margaret Collins',
  title: 'The summer we dance in the kitchen',
  content: 'Mom used to say he asked her to dance even when there was no music. We found this photo tucked inside her old recipe box...',
};

export const setShareModalMemory = (memoryId: string) => {
  useStore.setState({ shareModal: { timelineId: null, memoryId: memoryId } });
};
